﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconCubeSend } from "@tabler/icons-react";


export const EnvioMensualIcon = IconCubeSend;
export const EnvioMensualHelpText = '* Aquí puede ver la lista de envios mensuales.';

export class catEnvioMensual extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "EnvioMensual";
        this.def.columns.c_category_id.defaultValue = "EnvioMensual";
        this.Title = "Envios Mensuales";
        this.HelpText = EnvioMensualHelpText;
        this.Icon = EnvioMensualIcon;
    }
}

